var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.ecritures)?_c('b-table',{ref:"ecrituresTable",attrs:{"outlined":"","striped":"","items":_vm.ecritures,"fields":_vm.reportEcrituresFields}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }